import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import About from '@/components/About'
import Projects from '@/components/Projects'
import Project from '@/components/Project'
import Birds from '@/components/Birds'
import Donate from '@/components/Donate'
import News from '@/components/News'
import Post from '@/components/Post'
import Contact from '@/components/Contact'
import Privacy from '@/components/Privacy'

Vue.use(Router)

const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/about', name: 'about', component: About },
  { path: '/projects', name: 'projects', component: Projects },
  { path: '/projects/:slug', name: 'project', component: Project },
  { path: '/birds', name: 'birds', component: Birds },
  { path: '/donate', name: 'donate', component: Donate },
  { path: '/news', name: 'news', component: News },
  { path: '/news/:slug', name: 'article', component: Post },
  { path: '/contact', name: 'contact', component: Contact },
  { path: '/privacy-policy', name: 'privacy', component: Privacy }
]

export default new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 400)
    })
  }
})



// WEBPACK FOOTER //
// ./src/router.js